module.exports = __webpack_public_path__ + "media/images/icon/default/user-477061c7c00f58e560e9b0a04a4a1ddc.png";